/**
 * The Events container
 */
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import {
  Accordion,
  AccordionBody,
  AccordionHeader,
  AccordionItem,
} from "reactstrap";

import {
  // getFaqListAttributes,
  getFaqListRelationships,
  showFaqList,
} from "@bkry/bowline-redux/faqLists";
const { REACT_APP_PROJECT_ID } = env;
import { env } from "@bkry/bowline-utils";
import { useDispatch, useSelector } from "react-redux";
import { useSsrEffect } from "@issr/core";

/**
 * Faq container
 */

const FaqList = ({ slug }) => {
  const lang = useSelector((state) => state.i18nState.lang);
  const [open, setOpen] = useState("");
  const toggle = (id) => {
    if (open === id) {
      setOpen();
    } else {
      setOpen(id);
    }
  };
  // FAQLIST EXAMPLE, make sure you create a faqlist in backend with slug "dashboard"
  // remember to add all needed imports
  const dispatch = useDispatch();
  const dispatchApi = async () => {
    if (!slug) return;
    dispatch(
      showFaqList({
        projectId: REACT_APP_PROJECT_ID,
        id: slug,
      })
    );
  };
  useSsrEffect(dispatchApi);
  useEffect(dispatchApi, [dispatch, slug, lang]);

  // TODO should filter for slug not ID so we are using for now the first
  const faqListData = useSelector((state) => {
    return state?.faqLists?.dictionary[
      Object.keys(state?.faqLists?.dictionary).find(
        (key) => state?.faqLists?.dictionary[key]?.attributes?.slug === slug
      )
    ];
  });

  const faqListRelationships = useSelector((state) =>
    getFaqListRelationships(state, faqListData?.id)
  );

  // TODO should be extracted to a single component and used the right way (getFaqAttributes)
  const faqsDictionary = useSelector((state) => state?.faqs?.dictionary);

  return (
    <>
      {faqListData && (
        <div>
          <div className="mt-5 py-4 px-2">
            <p className="h4 fw-bold">{faqListData?.attributes?.title}</p>
          </div>
          <Accordion flush open={open} toggle={toggle} id={`faqlist-${slug}`}>
            {/* TODO: Do not use direct from relationships */}
            {faqListRelationships?.faqs?.data?.map((faqItem, i) => (
              <AccordionItem className="py-0" key={i}>
                <AccordionHeader targetId={`roadmap-${faqItem.id}`}>
                  {faqsDictionary[faqItem.id]?.attributes?.title}
                </AccordionHeader>
                <AccordionBody
                  accordionId={`roadmap-${faqItem.id}`}
                  className="small"
                >
                  <div
                    dangerouslySetInnerHTML={{
                      __html: faqsDictionary[faqItem.id]?.attributes?.content,
                    }}
                  ></div>
                </AccordionBody>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      )}
    </>
  );
};

FaqList.propTypes = {
  slug: PropTypes.string.isRequired,
};

/** export the component as redux connected component */
export default FaqList;
